import { u as ue } from "./storyblok-js-06eb3096.mjs";
import React, { forwardRef } from "react";
const StoryblokComponent = forwardRef(
  ({ blok, ...restProps }, ref) => {
    if (!blok) {
      console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      );
      return /* @__PURE__ */ React.createElement("div", null, "Please provide a blok property to the StoryblokComponent");
    }
    const Component = getComponent(blok.component);
    if (Component) {
      return /* @__PURE__ */ React.createElement(Component, { ref, blok, ...restProps });
    }
    return /* @__PURE__ */ React.createElement("div", null);
  }
);
StoryblokComponent.displayName = "StoryblokComponent";
let storyblokApiInstance = null;
let componentsMap = {};
const useStoryblokApi = () => {
  if (!storyblokApiInstance) {
    console.error(
      "You can't use getStoryblokApi if you're not loading apiPlugin."
    );
  }
  return storyblokApiInstance;
};
const getComponent = (componentKey) => {
  if (!componentsMap[componentKey]) {
    console.error(`Component ${componentKey} doesn't exist.`);
    return false;
  }
  return componentsMap[componentKey];
};
const storyblokInit = (pluginOptions = {}) => {
  const { storyblokApi } = ue(pluginOptions);
  storyblokApiInstance = storyblokApi;
  componentsMap = pluginOptions.components;
};
export {
  StoryblokComponent as S,
  getComponent as g,
  storyblokInit as s,
  useStoryblokApi as u
};
